<template>
    <div>
        <div v-if="loading" class="text-center p-5"><b-spinner variant="info" /></div>
        <b-alert v-else-if="loadError" show variant="danger">
            {{ $t('label.productConditionLoadError') }}
            <b-button size="sm" variant="outline-danger" @click="loadCondition">{{ $t('label.retryPermissionDefinitions') }}</b-button>
        </b-alert>
        <form v-else @submit.prevent="submitForm">
            <b-form-group :label="$t('label.name')">
                <b-form-input v-model.trim="form.name" required />
            </b-form-group>
            <b-form-checkbox v-model="form.isActive" switch>{{ $t('label.active') }}</b-form-checkbox>
            <hr>
            <div class="d-flex justify-content-end">
                <b-button type="button" variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
                <b-button type="submit" variant="info" :disabled="!status.save">
                    <span v-if="status.save">{{ $t(conditionUUID ? 'label.updateX' : 'label.createX', [$t('module.productCondition')]) }}</span>
                    <b-spinner v-else small />
                </b-button>
            </div>
        </form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { productConditionMethods } from '@/state/api';

export default {
    name: 'ProductConditionForm',
    props: { conditionUUID: { type: String, default: '' }, searchCriteria: { type: Object, required: true } },
    data() {
        return { loading: Boolean(this.conditionUUID), loadError: false, form: { uuid: '', name: '', isActive: true } };
    },
    computed: { ...mapState('api/productCondition', ['status', 'details']) },
    created() { if (this.conditionUUID) this.loadCondition(); },
    methods: {
        ...productConditionMethods,
        async loadCondition() {
            this.loading = true; this.loadError = false;
            try {
                const result = await this.getProductCondition({ uuid: this.conditionUUID });
                if (!result?.success) { this.loadError = true; return; }
                this.form = { ...this.details };
            } catch (error) { this.loadError = true; }
            finally { this.loading = false; }
        },
        async submitForm() {
            if (!this.status.save || !this.form.name.trim()) return;
            const action = this.conditionUUID ? this.updateProductCondition : this.createProductCondition;
            const result = await action({ data: { ...this.form, name: this.form.name.trim() }, filter: this.searchCriteria });
            if (result?.success) this.$emit('done');
        },
    },
};
</script>
